<div class="container">
  <div class="logo">
    <img width="250px" src="../../../../../assets/fiftylogo.png" alt="E11even logo" />
  </div>
  <h1 class="title">Sign In!</h1>

  <div class="number-box">
    <div class="input-container">
      <label for="name" class="label">Phone number </label>
      <form [formGroup]="mobileForm">
        <input required maxlength="10" formControlName="mobile" id="mobile" placeHolder="Phone number" class="phone-number" type="" />
      </form>
      <div *ngIf="mobile.invalid" class="ng-invalid">
        <p class="valid-number-text">Please enter a valid phone number</p>
      </div>
    </div>
  </div>

  <p class="verification-text">
    Please ensure you enter your mobile number correctly as we will use it to send you an OTP for verification where required
  </p>

  <button [disabled]="mobileForm.invalid" (click)="goToPasscode()" class="sign-in-button">Sign In!</button>
</div>

<div *ngIf="isMobileValidationLoading$ | async as isLoading">
  <div *ngIf="isLoading"></div>
</div>

<div *ngIf="mobileValidationFailure$ | async as fail">
  {{ fail.Message }}
  <div *ngIf="fail !== null">
    <app-error-modal [errorMessage]="fail.Message"></app-error-modal>
  </div>
</div>
